"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = watchers;
var _effects = require("redux-saga/effects");
var _sagas = require("../../../astercore/auth/login/redux/sagas");
var api = _interopRequireWildcard(require("../api/api"));
var actions = _interopRequireWildcard(require("./actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* getHcCartApi(params) {
  try {
    yield (0, _effects.put)(actions.GET_HC_CART_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getHcCart, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_HC_CART_API.success(mainResponse));
    yield (0, _effects.put)({
      type: actions.SET_HC_CART_INFO,
      data: {
        cartInfo: mainResponse
      }
    });
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_HC_CART_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* updateCartApi(params) {
  try {
    yield (0, _effects.put)(actions.UPDATE_CART_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.updateCart, params.data.params, tokenData);
    yield (0, _effects.put)(actions.UPDATE_CART_API.success(mainResponse));
    yield (0, _effects.put)({
      type: actions.SET_HC_CART_INFO,
      data: {
        cartInfo: mainResponse
      }
    });
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.UPDATE_CART_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* updateCartMapUserApi(params) {
  try {
    yield (0, _effects.put)(actions.UPDATE_CART_MAP_USER_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.updateCartMapUser, params.data.params, tokenData);
    yield (0, _effects.put)(actions.UPDATE_CART_MAP_USER_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.UPDATE_CART_MAP_USER_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* createCartApi(params) {
  try {
    yield (0, _effects.put)(actions.CREATE_CART_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.createCart, params.data.params, tokenData);
    yield (0, _effects.put)(actions.CREATE_CART_API.success(mainResponse));
    yield (0, _effects.put)({
      type: actions.SET_HC_CART_INFO,
      data: {
        cartInfo: mainResponse
      }
    });
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.CREATE_CART_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* deleteCartApi(params) {
  try {
    yield (0, _effects.put)(actions.DELETE_CART_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.deleteCart, params.data.params, tokenData);
    yield (0, _effects.put)(actions.DELETE_CART_API.success(mainResponse));
    yield (0, _effects.put)({
      type: actions.SET_HC_CART_INFO,
      data: {
        cartInfo: {
          count: 0
        }
      }
    });
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.DELETE_CART_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* deleteCartEntryNumberApi(params) {
  try {
    yield (0, _effects.put)(actions.DELETE_CART_ENTRY_NUMBER_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.deleteCartEntryNumber, params.data.params, tokenData);
    yield (0, _effects.put)(actions.DELETE_CART_ENTRY_NUMBER_API.success(mainResponse));
    yield (0, _effects.put)({
      type: actions.SET_HC_CART_INFO,
      data: {
        cartInfo: mainResponse
      }
    });
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.DELETE_CART_ENTRY_NUMBER_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* deleteMultipleCartEntryNumber(params) {
  try {
    yield (0, _effects.put)(actions.DELETE_MULTIPLE_CART_ENTRY_NUMBER_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.deleteMultipleCartEntryNumber, params.data.params, tokenData);
    yield (0, _effects.put)(actions.DELETE_MULTIPLE_CART_ENTRY_NUMBER_API.success(mainResponse));
    yield (0, _effects.put)({
      type: actions.SET_HC_CART_INFO,
      data: {
        cartInfo: mainResponse
      }
    });
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.DELETE_MULTIPLE_CART_ENTRY_NUMBER_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getCartCountApi(params) {
  try {
    yield (0, _effects.put)(actions.GET_CART_COUNT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getCartCount, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_CART_COUNT_API.success(mainResponse));
    yield (0, _effects.put)({
      type: actions.SET_HC_CART_INFO,
      data: {
        cartInfo: mainResponse
      }
    });
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_CART_COUNT_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getCartSlotApi(params) {
  try {
    yield (0, _effects.put)(actions.GET_CART_SLOT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getCartSlot, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_CART_SLOT_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_CART_SLOT_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getIndividualCartSlotApi(params) {
  try {
    yield (0, _effects.put)(actions.GET_INDIVIDUAL_CART_SLOT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getIndividualCartSlot, params.data.params, tokenData);
    const updateRes = {
      data: mainResponse
    };
    yield (0, _effects.put)(actions.GET_INDIVIDUAL_CART_SLOT_API.success(updateRes));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_INDIVIDUAL_CART_SLOT_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getIndividualCartSlotApiEvery(params) {
  try {
    yield (0, _effects.put)(actions.GET_INDIVIDUAL_CART_SLOT_API_EVERY.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getIndividualCartSlot, params.data.params, tokenData);
    const updateRes = {
      data: mainResponse
    };
    yield (0, _effects.put)(actions.GET_INDIVIDUAL_CART_SLOT_API_EVERY.success(updateRes));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_INDIVIDUAL_CART_SLOT_API_EVERY.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getMainCartSlotApi(params) {
  try {
    yield (0, _effects.put)(actions.GET_MAIN_CART_SLOT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getMainCartSlot, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_MAIN_CART_SLOT_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_MAIN_CART_SLOT_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getUpcomingOrdersAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_UPCOMING_ORDERS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getUpcomingOrders, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_UPCOMING_ORDERS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_UPCOMING_ORDERS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getCompletedOrdersAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_COMPLETED_ORDERS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getCompletedOrders, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_COMPLETED_ORDERS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_COMPLETED_ORDERS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* watchers() {
  yield (0, _effects.takeLatest)(actions.GET_HC_CART, getHcCartApi);
  yield (0, _effects.takeLatest)(actions.UPDATE_CART, updateCartApi);
  yield (0, _effects.takeLatest)(actions.UPDATE_CART_MAP_USER, updateCartMapUserApi);
  yield (0, _effects.takeLatest)(actions.CREATE_CART, createCartApi);
  yield (0, _effects.takeLatest)(actions.DELETE_CART, deleteCartApi);
  yield (0, _effects.takeLatest)(actions.DELETE_CART_ENTRY_NUMBER, deleteCartEntryNumberApi);
  yield (0, _effects.takeLatest)(actions.DELETE_MULTIPLE_CART_ENTRY_NUMBER, deleteMultipleCartEntryNumber);
  yield (0, _effects.takeLatest)(actions.GET_CART_COUNT, getCartCountApi);
  yield (0, _effects.takeLatest)(actions.GET_CART_SLOT, getCartSlotApi);
  yield (0, _effects.takeLatest)(actions.GET_INDIVIDUAL_CART_SLOT, getIndividualCartSlotApi);
  yield (0, _effects.takeLatest)(actions.GET_MAIN_CART_SLOT, getMainCartSlotApi);
  yield (0, _effects.takeLatest)(actions.GET_UPCOMING_ORDERS, getUpcomingOrdersAPI);
  yield (0, _effects.takeEvery)(actions.GET_INDIVIDUAL_CART_SLOT_EVERY, getIndividualCartSlotApiEvery);
  yield (0, _effects.takeLatest)(actions.GET_COMPLETED_ORDERS, getCompletedOrdersAPI);
}